module.exports = __webpack_public_path__ + "img/ks_aso.ba921d41.png";